<template>
  <v-container fluid class="theme-bg-card">
    <v-row>
      <v-col cols="12" sm="12">
        <BaseCard heading="Calendar - Events" class="theme-bg-card">
          <CalendarEvents  style="background-color:rgba(48, 64, 87, 0.1)"></CalendarEvents>
        </BaseCard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Calendar",

  data: () => ({
    page: {
      title: "FullCalendar"
    },
    breadcrumbs: [
      {
        text: "Apps",
        disabled: false,
        to: "#"
      },
      {
        text: "FullCalendar",
        disabled: true
      }
    ]
  }),
  components: {
    CalendarEvents: () =>
      import("@/components/vuetifyComponents/calendar/CalendarEvents"),
  }
};
</script>


<style scoped>

.theme-bg-card {
  background: rgba(48, 64, 87, 0.1);
  outline-color: #42da91;
  color: #fff;
  border: 1px solid transparent;
  box-shadow: 0 2px 4px rgba(0,0,0,0.50), 0 6px 6px rgba(0,0,0,0.30);
}

</style>
